import "assets/css/modal.css";
import "styles/custom.css";
import * as React from "react";
import {
  getRegionNames,
  getExistingFeatureFlags,
  updateFeatureFlags,
  updateFeatureFlagsCC,
  updateGlobalFeatureFlags,
  addFeatureFlag,
  addGlobalFeatureFlag,
  getMainFeatures,
  getExistingCCFlags,
  getCCMainFeatures,
  addFeatureFlagCC,
  addGlobalFeatureFlagCC,
  clearFlagCacheCC,
  deleteFeatureFlag,
  deleteFeatureFlagCC,
  isAdmin,
} from "../components/Requests/Requests";
import {
  StandardScreen,
  StandardDropdown,
  StandardTextField,
  StandardButton,
  StandardCheckbox,
  StatusMessage,
  FeatureFlagsTable,
  PageLayout,
  StandardText,
  TextFieldWithTooltip,
} from "../components/Layout";
import theme from "../styles/theme.js";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "office-ui-fabric-react/lib/Dialog";
import {
  PrimaryButton,
  DefaultButton,
} from "office-ui-fabric-react/lib/Button";

const cacheableFlagNames = {
  SkipWebhookProcessing: "SkipWebhookProcessing",
  FrictionlessSharepointExperience: "FrictionlessSharepointExperience",
};

class FeatureFlags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // ICP - Enable/Disable Existing Features - Variables
      existingFeatureChosen: "",
      mainFeatures: [],
      description: "",
      error: "",
      message: "",
      loadingManage: false,
      featureFlags: [],

      // ICP - Add New Feature Flag - Variables
      newFeature: false,
      newFeatureName: "",
      existingFeatureToAddChosen: "",
      featureFlagLevelChosen: "",
      newDescription: "",
      tenantName: "",
      spHostUrl: "",
      addNewError: "",
      addNewMessage: "",
      addFlagDescription: "",
      loadingAdd: false,

      // Content Connector - Enable/Disable Existing Features - Variables
      regionNameChosenCC: "",
      existingFeatureChosenCC: "",
      errorCC: "",
      messageCC: "",
      warningCC: "",
      mainFeaturesCC: [],
      featureFlagsCC: [],

      // Content Connector - Add New Feature Flag - Variables
      regionNameChosenNewCC: "",
      existingFeatureToAddChosenCC: "",
      featureFlagLevelChosenCC: "",
      addNewMessageCC: "",
      addNewErrorCC: "",
      addNewWarningCC: "",
      spHostUrlCC: "",
      tenantIdCC: "",
      teamIdCC: "",
      newFeatureCC: false,
      newFeatureNameCC: "",
      regionNames: [],

      // New Feature Variables - to be refactored
      manageError: "",
      manageMessage: "",
      productChosen: "",
      productChosenNew: "",
      manageEnvironment: "",
      manageFeature: "",
      groupId: "",

      // Delete Feature Flag
      hideDeleteDialog: true,
      flagToDelete: null,
      isAdmin: false,
    };
  }

  componentDidMount() {
    this.initializeSettings();
  }

  initializeSettings() {
    this.getRegionNames();
    this.checkIsAdmin();
  }

  async checkIsAdmin() {
    try {
      let response = await isAdmin(this.props.accessToken);
      if (response.status === 200) {
        let data = await response.json();
        this.setState({ isAdmin: data.isAdmin });
      }
    } catch (error) {
      this.setState({ isAdmin: false });
    }
  }

  async getRegionNames() {
    this.setState({ loadingManage: true, loadingAdd: true });
    try {
      let response = await getRegionNames(this.props.accessToken);
      if (response.status === 200) {
        let data = await response.json();
        this.setState({
          loadingManage: false,
          loadingAdd: false,
          regionNames: data.map((item) => ({ key: item, text: item })),
        });
      } else {
        this.setState({
          loadingManage: false,
          loadingAdd: false,
          error: "Something went wrong",
          message: "",
        });
      }
    } catch (error) {
      this.setState({
        loadingManage: false,
        loadingAdd: false,
        error: "Something went wrong",
        message: "",
      });
    }
  }

  async getMainFeatures(product, isManageSection = true) {
    this.setState({
      [isManageSection ? "loadingManage" : "loadingAdd"]: true,
    });

    try {
      let requestBody = { Product: product };
      let response = await getMainFeatures(this.props.accessToken, requestBody);
      if (response.status === 200) {
        let data = await response.json();
        this.setState({
          [isManageSection ? "loadingManage" : "loadingAdd"]: false,
          mainFeatures: data.map((item) => ({
            key: item.name,
            text: item.name.replace(/([a-z])([A-Z])/g, "$1 $2"),
            description: item.description,
          })),
        });
      } else {
        this.setState({
          [isManageSection ? "loadingManage" : "loadingAdd"]: false,
          error: "Something went wrong",
          message: "",
        });
      }
    } catch (error) {
      this.setState({
        [isManageSection ? "loadingManage" : "loadingAdd"]: false,
        error: "Something went wrong",
        message: "",
      });
    }
  }

  async getCCMainFeatures(regionName, isManageSection = true) {
    this.setState({
      [isManageSection ? "loadingManage" : "loadingAdd"]: true,
    });

    try {
      let requestBody = { RegionName: regionName };
      let response = await getCCMainFeatures(
        this.props.accessToken,
        requestBody,
      );
      if (response.status === 200) {
        let data = await response.json();
        this.setState({
          [isManageSection ? "loadingManage" : "loadingAdd"]: false,
          mainFeaturesCC: data.map((item) => ({
            key: item,
            text: item.replace(/([a-z])([A-Z])/g, "$1 $2"),
          })),
        });
      } else {
        this.setState({
          [isManageSection ? "loadingManage" : "loadingAdd"]: false,
          error: "Something went wrong",
          message: "",
        });
      }
    } catch (error) {
      this.setState({
        [isManageSection ? "loadingManage" : "loadingAdd"]: false,
        error: "Something went wrong",
        message: "",
      });
    }
  }

  async getExistingFeatureFlags() {
    this.setState({ loadingManage: true, error: "", message: "" });
    try {
      let requestBody = { Feature: this.state.existingFeatureChosen };
      let response = await getExistingFeatureFlags(
        this.props.accessToken,
        requestBody,
      );
      let featureFlagsEnabled = await response.json();

      if (response.status === 200) {
        if (featureFlagsEnabled.length === 0) {
          this.setState({
            loadingManage: false,
            error: "There are currently no feature flags for this feature.",
            featureFlags: [],
          });
        } else {
          // Convert the object to an array format for the table
          const featureFlags = Object.entries(featureFlagsEnabled).map(
            ([name, enabled]) => ({
              name,
              enabled,
            }),
          );
          this.setState({ loadingManage: false, featureFlags });
        }
      } else {
        this.setState({
          loadingManage: false,
          error: "Something went wrong",
          featureFlags: [],
        });
      }
    } catch (error) {
      this.setState({
        loadingManage: false,
        error: "Something went wrong",
        featureFlags: [],
      });
    }
  }

  async getExistingCCFlags() {
    this.setState({
      loadingManage: true,
      errorCC: "",
      messageCC: "",
      warningCC: "",
    });
    try {
      let requestBody = {
        FeatureName: this.state.existingFeatureChosenCC,
        RegionName:
          this.state.regionNameChosenNewCC || this.state.manageEnvironment,
      };
      let response = await getExistingCCFlags(
        this.props.accessToken,
        requestBody,
      );
      let featureFlagsEnabledCC = await response.json();

      if (response.status === 200) {
        if (featureFlagsEnabledCC.length === 0) {
          this.setState({
            loadingManage: false,
            errorCC: "There are currently no feature flags for this feature.",
            featureFlagsCC: [],
          });
        } else {
          this.setState({
            loadingManage: false,
            featureFlagsCC: featureFlagsEnabledCC,
          });
        }
      } else {
        this.setState({
          loadingManage: false,
          errorCC: "Something went wrong",
          featureFlagsCC: [],
        });
      }
    } catch (error) {
      this.setState({
        loadingManage: false,
        errorCC: "Something went wrong",
        featureFlagsCC: [],
      });
    }
  }

  async updateFeatureFlags(featureFlag, isEnabled) {
    this.setState((prevState) => ({
      featureFlags: prevState.featureFlags.map((flag) =>
        flag.name === featureFlag.name ? { ...flag, enabled: isEnabled } : flag,
      ),
      loadingManage: true,
    }));
    try {
      let requestBody = {
        FeatureFlag: featureFlag.name,
        IsEnabled: isEnabled,
      };

      let response = featureFlag.name.includes("__")
        ? await updateFeatureFlags(this.props.accessToken, requestBody)
        : await updateGlobalFeatureFlags(this.props.accessToken, requestBody);

      if (response.status === 200) {
        let data = await response.json();
        this.setState({ message: data.message, loadingManage: false });
        // this.getExistingFeatureFlags();
      } else if (response.status === 401) {
        this.setState({
          loadingManage: false,
          error:
            "You are not permitted to enable/disable a global feature flag. You must request admin permissions",
        });
      } else {
        this.setState({ loadingManage: false, error: "Something went wrong" });
      }
    } catch (error) {
      this.setState({ loadingManage: false, error: "Something went wrong" });
    }
  }

  showDeleteDialog(flag) {
    this.setState({ hideDeleteDialog: false, flagToDelete: flag });
  }

  async confirmDeleteFlag() {
    this.setState({ loadingManage: true, error: "", message: "" });
    try {
      let requestBody = { FeatureFlagName: this.state.flagToDelete.name };
      let response = await deleteFeatureFlag(
        this.props.accessToken,
        requestBody,
      );

      if (response.status === 200) {
        let data = await response.json();
        this.setState((prevState) => ({
          loadingManage: false,
          message: data.message,
          hideDeleteDialog: true,
          flagToDelete: null,
          featureFlags: prevState.featureFlags.filter(
            (flag) => flag.name !== prevState.flagToDelete.name,
          ),
        }));
      } else if (response.status === 401) {
        this.setState({
          loadingManage: false,
          error:
            "You are not permitted to delete a global feature flag. You must request admin permissions.",
          hideDeleteDialog: true,
          flagToDelete: null,
        });
      } else if (response.status === 404) {
        this.setState({
          loadingManage: false,
          error: "Feature flag not found",
          hideDeleteDialog: true,
          flagToDelete: null,
        });
      } else {
        this.setState({
          loadingManage: false,
          error: "Something went wrong",
          hideDeleteDialog: true,
          flagToDelete: null,
        });
      }
    } catch (error) {
      this.setState({
        loadingManage: false,
        error: "Something went wrong",
        hideDeleteDialog: true,
        flagToDelete: null,
      });
    }
  }

  async confirmDeleteFlagCC() {
    this.setState({ loadingManage: true, errorCC: "", messageCC: "" });
    try {
      let requestBody = {
        FeatureName: this.state.flagToDelete.featureName,
        RegionName: this.state.manageEnvironment,
        TenantId: this.state.flagToDelete.tenantId,
        SpHost: this.state.flagToDelete.spHost,
        TeamId: this.state.flagToDelete.teamId,
      };
      let response = await deleteFeatureFlagCC(
        this.props.accessToken,
        requestBody,
      );

      if (response.status === 200) {
        let data = await response.json();
        this.setState((prevState) => ({
          loadingManage: false,
          messageCC: data.message,
          hideDeleteDialog: true,
          flagToDelete: null,
          featureFlagsCC: prevState.featureFlagsCC.filter(
            (flag) =>
              !(
                flag.featureName === prevState.flagToDelete.featureName &&
                flag.tenantId === prevState.flagToDelete.tenantId &&
                flag.spHost === prevState.flagToDelete.spHost &&
                flag.teamId === prevState.flagToDelete.teamId
              ),
          ),
        }));
      } else if (response.status === 404) {
        this.setState({
          loadingManage: false,
          errorCC: "Feature flag not found",
          hideDeleteDialog: true,
          flagToDelete: null,
        });
      } else {
        this.setState({
          loadingManage: false,
          errorCC: "Something went wrong",
          hideDeleteDialog: true,
          flagToDelete: null,
        });
      }
    } catch (error) {
      this.setState({
        loadingManage: false,
        errorCC: "Something went wrong",
        hideDeleteDialog: true,
        flagToDelete: null,
      });
    }
  }

  async updateFeatureFlagsCC(featureFlag, isEnabled) {
    this.setState((prevState) => ({
      featureFlagsCC: prevState.featureFlagsCC.map((flag) =>
        flag.featureName === featureFlag.featureName &&
        flag.tenantId === featureFlag.tenantId
          ? { ...flag, enabled: isEnabled }
          : flag,
      ),
      loadingManage: true,
    }));
    try {
      let requestBody = {
        FeatureName: featureFlag.featureName,
        Enabled: isEnabled,
        TenantId: featureFlag.tenantId,
        SpHost: featureFlag.spHost,
        TeamId: featureFlag.teamId,
        RegionName: this.state.manageEnvironment,
      };

      let response = await updateFeatureFlagsCC(
        this.props.accessToken,
        requestBody,
      );
      if (response.status === 200) {
        let data = await response.json();
        this.setState({
          messageCC: data.message,
          warningCC: "",
          loadingManage: false,
        });
        this.getExistingCCFlags();

        if (
          requestBody.FeatureName == cacheableFlagNames.SkipWebhookProcessing ||
          requestBody.FeatureName ==
            cacheableFlagNames.FrictionlessSharepointExperience
        ) {
          try {
            response = await clearFlagCacheCC(
              this.props.accessToken,
              requestBody,
            );
            if (response.status === 200) {
              this.setState({
                messageCC: "Feature flag changes should be active immediately.",
              });
            } else if (response.status !== 200) {
              this.setState({
                warningCC:
                  "Feature flag updated, but cache could not be cleared. This could take up to 24hrs to reflect.",
              });
            }
          } catch {
            this.setState({
              warningCC:
                "Feature flag updated, but cache could not be cleared. This could take up to 24hrs to reflect.",
            });
          }
        }
      } else {
        this.setState({
          loadingManage: false,
          errorCC: "Something went wrong",
        });
      }
    } catch (error) {
      this.setState({ loadingManage: false, errorCC: "Something went wrong" });
    }
  }

  async addFeatureFlag() {
    this.setState({ loadingAdd: true, addNewError: "", addNewMessage: "" });
    try {
      let requestBody;
      let response;

      if (this.state.newFeature) {
        // Adding a global feature
        requestBody = {
          Feature: this.state.newFeatureName,
          Description: this.state.newDescription,
          Platform: this.state.productChosenNew,
        };
        response = await addGlobalFeatureFlag(
          this.props.accessToken,
          requestBody,
        );
      } else {
        const strippedTenantName = this.cleanURL(this.state.tenantName);
        const strippedSpHostUrl = this.cleanURL(this.state.spHostUrl);

        // Adding a feature flag to existing feature
        let requestBody = {
          Feature: this.state.existingFeatureToAddChosen,
          FeatureFlagLevel: this.state.featureFlagLevelChosen,
          TenantName: strippedTenantName,
          SPHostUrl: strippedSpHostUrl,
          Platform: this.state.productChosenNew,
          GroupId: this.state.groupId,
        };
        response = await addFeatureFlag(this.props.accessToken, requestBody);
      }

      if (response.status === 200) {
        let data = await response.json();
        this.setState({ addNewMessage: data.message, loadingAdd: false });
        this.getExistingFeatureFlags();
      } else if (response.status === 401) {
        this.setState({
          loadingAdd: false,
          addNewError:
            "You are not permitted to create a global feature flag. You must request admin permissions",
        });
      } else {
        this.setState({
          loadingAdd: false,
          addNewError: "Something went wrong",
        });
      }
    } catch (error) {
      this.setState({ loadingAdd: false, addNewError: "Something went wrong" });
    }
  }

  async addGlobalFeatureFlagCC() {
    this.setState({
      loadingAdd: true,
      addNewErrorCC: "",
      addNewMessageCC: "",
      addNewWarningCC: "",
    });
    try {
      let requestBody = {
        FeatureName: this.state.newFeatureNameCC,
        RegionName: this.state.regionNameChosenNewCC,
      };

      let response = await addGlobalFeatureFlagCC(
        this.props.accessToken,
        requestBody,
      );

      if (response.status === 200) {
        let data = await response.json();
        this.setState({ addNewMessageCC: data.message, loadingAdd: false });
        // Refresh the feature list so the new flag is immediately selectable.
        this.getCCMainFeatures(this.state.regionNameChosenNewCC, false);
      } else if (response.status === 401) {
        this.setState({
          loadingAdd: false,
          addNewErrorCC:
            "You are not permitted to create a global feature flag. You must request admin permissions.",
        });
      } else if (response.status === 409) {
        this.setState({
          loadingAdd: false,
          addNewErrorCC:
            "A global feature flag for this feature already exists in this environment.",
        });
      } else {
        this.setState({
          loadingAdd: false,
          addNewErrorCC: "Something went wrong",
        });
      }
    } catch (error) {
      this.setState({
        loadingAdd: false,
        addNewErrorCC: "Something went wrong",
      });
    }
  }

  async addFeatureFlagCC() {
    this.setState({
      loadingAdd: true,
      addNewErrorCC: "",
      addNewMessageCC: "",
      addNewWarningCC: "",
    });
    try {
      let requestBody = {
        FeatureName: this.state.existingFeatureToAddChosenCC,
        FeatureFlagLevel: this.state.featureFlagLevelChosenCC,
        TenantId: this.state.tenantIdCC,
        SPHost: this.state.spHostUrlCC,
        TeamId: this.state.teamIdCC,
        RegionName: this.state.regionNameChosenNewCC,
      };

      let response = await addFeatureFlagCC(
        this.props.accessToken,
        requestBody,
      );
      if (response.status === 200) {
        let data = await response.json();
        this.setState({
          addNewMessageCC: data.message,
          addNewWarningCC: "",
          loadingAdd: false,
        });
        this.getExistingCCFlags();

        if (
          requestBody.FeatureName == cacheableFlagNames.SkipWebhookProcessing ||
          requestBody.FeatureName ==
            cacheableFlagNames.FrictionlessSharepointExperience
        ) {
          try {
            response = await clearFlagCacheCC(
              this.props.accessToken,
              requestBody,
            );
            if (response.status === 200) {
              this.setState({
                messageCC: "Feature flag should be active immediately.",
              });
            } else if (response.status !== 200) {
              this.setState({
                addNewWarningCC:
                  "Feature flag created, but cache could not be cleared. This could take up to 24hrs to reflect.",
              });
            }
          } catch {
            this.setState({
              addNewWarningCC:
                "Feature flag created, but cache could not be cleared. This could take up to 24hrs to reflect.",
            });
          }
        }
      } else {
        this.setState({
          loadingAdd: false,
          addNewErrorCC: "Something went wrong",
        });
      }
    } catch (error) {
      this.setState({
        loadingAdd: false,
        addNewErrorCC: "Something went wrong",
      });
    }
  }

  // Event handlers
  onSelectRegionNameCC = (event, item) => {
    this.setState({
      regionNameChosenCC: item.key,
      messageCC: "",
      errorCC: "",
      warningCC: "",
    });
    this.getCCMainFeatures(item.key);
  };

  onSelectRegionNameNewCC = (event, item) => {
    this.setState({
      regionNameChosenNewCC: item.key,
      addNewMessageCC: "",
      addNewErrorCC: "",
    });
    this.getCCMainFeatures(item.key, false); // false = add section
  };

  onSelectFeature = (event, item) => {
    this.setState({
      existingFeatureChosen: item.key,
      description: item.description,
      error: "",
      message: "",
      featureFlags: [],
    });
  };

  onSelectFeatureCC = (event, item) => {
    this.setState({
      existingFeatureChosenCC: item.key,
      messageCC: "",
      errorCC: "",
      warningCC: "",
      featureFlagsCC: [],
    });
  };

  onSelectFeatureToAdd = (event, item) => {
    this.setState({
      existingFeatureToAddChosen: item.key,
      addFlagDescription: item.description,
      addNewError: "",
      addNewMessage: "",
    });
  };

  onSelectFeatureToAddCC = (event, item) => {
    this.setState({
      existingFeatureToAddChosenCC: item.key,
      addNewMessageCC: "",
      addNewErrorCC: "",
      addNewWarningCC: "",
    });
  };

  onSelectFeatureFlagLevel = (event, item) => {
    this.setState({ featureFlagLevelChosen: item.key });
  };

  onSelectFeatureFlagLevelCC = (event, item) => {
    this.setState({
      featureFlagLevelChosenCC: item.key,
      tenantIdCC: "",
      spHostUrlCC: "",
      teamIdCC: "",
    });
  };

  onCheckNewFeature = (event, checked) => {
    this.setState({
      newFeature: checked,
      existingFeatureToAddChosen: "",
      featureFlagLevelChosen: "",
      newFeatureName: "",
      newDescription: "",
      tenantName: "",
      spHostUrl: "",
      addNewError: "",
      addNewMessage: "",
    });
  };

  onCheckNewFeatureCC = (event, checked) => {
    this.setState({
      newFeatureCC: checked,
      newFeatureNameCC: "",
      existingFeatureToAddChosenCC: "",
      featureFlagLevelChosenCC: "",
      tenantIdCC: "",
      spHostUrlCC: "",
      teamIdCC: "",
      addNewMessageCC: "",
      addNewErrorCC: "",
      addNewWarningCC: "",
    });
  };

  onSelectProduct = (_, item) => {
    this.setState({
      productChosen: item.key,
      existingFeatureChosen: "",
      existingFeatureChosenCC: "",
      manageEnvironment: "",
      featureFlags: [],
      featureFlagsCC: [],
      error: "",
      errorCC: "",
      warningCC: "",
      message: "",
      messageCC: "",
    });
    if (item.key !== "cc") {
      this.getMainFeatures(item.key, true); // true = manage section
    }
  };

  onSelectProductNew = (_, item) => {
    this.setState({ productChosenNew: item.key });
    if (item.key !== "cc") {
      this.getMainFeatures(item.key, false); // false = add section
    }
  };

  onChangeManageEnvironment = (_, item) => {
    this.setState({ manageEnvironment: item.key });
    this.getCCMainFeatures(item.key, true); // true = manage section
  };

  cleanURL = (url) => {
    return url.replace(/^https?:\/\//i, "");
  };

  render() {
    const {
      loadingManage,
      loadingAdd,
      error,
      message,
      errorCC,
      messageCC,
      warningCC,
      addNewError,
      addNewMessage,
      addNewErrorCC,
      addNewMessageCC,
      addNewWarningCC,
      existingFeatureChosen,
      existingFeatureChosenCC,
      regionNameChosenCC,
      regionNameChosenNewCC,
      existingFeatureToAddChosen,
      existingFeatureToAddChosenCC,
      featureFlagLevelChosen,
      featureFlagLevelChosenCC,
      newFeature,
      newFeatureName,
      newFeatureCC,
      newFeatureNameCC,
      newDescription,
      tenantName,
      spHostUrl,
      tenantIdCC,
      spHostUrlCC,
      teamIdCC,
      description,
      addFlagDescription,
      featureFlags,
      featureFlagsCC,
      mainFeatures,
      mainFeaturesCC,
      regionNames,
      productChosen,
      productChosenNew,
      manageEnvironment,
      groupId,
    } = this.state;

    return (
      <PageLayout>
        <StandardScreen
          title="Manage Existing Feature Flags"
          description="Enable or disable existing feature flags across products. Managing global flags is an admin only feature"
          loading={loadingManage}
        >
          <StandardDropdown
            label="Product"
            placeholder="Target Product"
            options={[
              { key: "icp", text: "ICP" },
              { key: "cc", text: "Content Connector" },
              { key: "collabApp", text: "Collab App" },
              { key: "workflows", text: "Workflows" },
            ]}
            selectedKey={productChosen}
            onChange={this.onSelectProduct}
          ></StandardDropdown>

          {productChosen !== "" && (
            <div>
              {productChosen === "cc" && (
                <StandardDropdown
                  label="Environment"
                  placeholder="Select Environment"
                  options={regionNames}
                  selectedKey={manageEnvironment}
                  onChange={this.onChangeManageEnvironment}
                ></StandardDropdown>
              )}

              <StandardDropdown
                label="Feature"
                placeholder="Select Existing Feature"
                options={productChosen === "cc" ? mainFeaturesCC : mainFeatures}
                selectedKey={
                  productChosen === "cc"
                    ? existingFeatureChosenCC
                    : existingFeatureChosen
                }
                onChange={
                  productChosen === "cc"
                    ? this.onSelectFeatureCC
                    : this.onSelectFeature
                }
                disabled={productChosen == ""}
              ></StandardDropdown>

              <StandardButton
                text="Search"
                onClick={() => {
                  if (productChosen === "cc") {
                    this.getExistingCCFlags();
                  } else {
                    this.getExistingFeatureFlags();
                  }
                }}
                disabled={
                  productChosen === "" ||
                  (productChosen === "cc" &&
                    (!manageEnvironment || !existingFeatureChosenCC)) ||
                  (productChosen !== "cc" && !existingFeatureChosen)
                }
              ></StandardButton>

              <StatusMessage type="error">
                {productChosen === "cc" ? errorCC : error}
              </StatusMessage>
              <StatusMessage type="success">
                {productChosen === "cc" ? messageCC : message}
              </StatusMessage>
              {productChosen === "cc" && (
                <StatusMessage type="warning">{warningCC}</StatusMessage>
              )}

              <FeatureFlagsTable
                featureFlags={
                  productChosen === "cc" ? featureFlagsCC : featureFlags
                }
                onToggleFlag={
                  productChosen === "cc"
                    ? this.updateFeatureFlagsCC.bind(this)
                    : this.updateFeatureFlags.bind(this)
                }
                showTenantColumns={productChosen === "cc"}
                onDeleteFlag={this.showDeleteDialog.bind(this)}
                isAdmin={this.state.isAdmin}
              />
            </div>
          )}
        </StandardScreen>

        <StandardScreen
          title="Add a New Feature Flag"
          description="Add a new feature flag to a specific product. Adding global flags is an admin only feature"
          loading={loadingAdd}
        >
          <StandardDropdown
            label="Product"
            placeholder="Target Product"
            options={[
              { key: "icp", text: "ICP" },
              { key: "cc", text: "Content Connector" },
              { key: "collabApp", text: "Collab App" },
              { key: "workflows", text: "Workflows" },
            ]}
            selectedKey={productChosenNew}
            onChange={this.onSelectProductNew}
          ></StandardDropdown>

          {(productChosenNew === "icp" ||
            productChosenNew === "collabApp" ||
            productChosenNew === "workflows") && (
            <div>
              <StandardCheckbox
                label="Add feature globally"
                checked={newFeature}
                onChange={this.onCheckNewFeature}
              ></StandardCheckbox>

              {!newFeature && (
                <StandardDropdown
                  label="Feature"
                  placeholder="Target Feature"
                  options={mainFeatures}
                  selectedKey={existingFeatureToAddChosen}
                  onChange={this.onSelectFeatureToAdd}
                ></StandardDropdown>
              )}

              {!newFeature && addFlagDescription != "" && (
                <StandardText
                  color={theme.colors.primary}
                  variant="small"
                  style={{ marginTop: "-16px", marginBottom: "15px" }}
                >
                  Description: <b>{addFlagDescription}</b>
                </StandardText>
              )}

              {newFeature && (
                <>
                  <StandardTextField
                    label="Feature Name"
                    placeholder="New Feature Name"
                    value={newFeatureName}
                    onChange={(event, newValue) =>
                      this.setState({ newFeatureName: newValue })
                    }
                  ></StandardTextField>

                  <StandardTextField
                    label="Description"
                    placeholder="Feature Description"
                    value={newDescription}
                    onChange={(event, newValue) =>
                      this.setState({ newDescription: newValue })
                    }
                  ></StandardTextField>
                </>
              )}

              {!newFeature && existingFeatureToAddChosen && (
                <StandardDropdown
                  label="Flag Level"
                  placeholder="Feature Flag Level"
                  options={[
                    { key: "tenant", text: "Tenant" },
                    { key: "site", text: "Site" },
                  ]}
                  selectedKey={featureFlagLevelChosen}
                  onChange={this.onSelectFeatureFlagLevel}
                ></StandardDropdown>
              )}

              {!newFeature && featureFlagLevelChosen === "tenant" && (
                <div>
                  {this.state.productChosenNew === "icp" && (
                    <StandardTextField
                      label="Tenant URL"
                      placeholder="Tenant URL"
                      value={tenantName}
                      onChange={(_, newValue) =>
                        this.setState({ tenantName: newValue })
                      }
                    ></StandardTextField>
                  )}
                  {(this.state.productChosenNew === "collabApp" ||
                    this.state.productChosenNew === "workflows") && (
                    <StandardTextField
                      label="Tenant ID"
                      placeholder="Tenant ID"
                      value={tenantName}
                      onChange={(_, newValue) =>
                        this.setState({ tenantName: newValue })
                      }
                    ></StandardTextField>
                  )}
                </div>
              )}

              {!newFeature && featureFlagLevelChosen === "site" && (
                <StandardTextField
                  label="Site URL"
                  placeholder="Site URL"
                  value={spHostUrl}
                  onChange={(event, newValue) =>
                    this.setState({ spHostUrl: newValue })
                  }
                ></StandardTextField>
              )}

              {this.state.productChosenNew === "collabApp" &&
                (this.state.featureFlagLevelChosen === "site" ||
                  this.state.featureFlagLevelChosen === "tenant") && (
                  <TextFieldWithTooltip
                    label="Group Id (Optional)"
                    placeholder="Group Id"
                    value={groupId}
                    onChange={(event, newValue) =>
                      this.setState({ groupId: newValue })
                    }
                    tooltipContent={
                      <StandardText
                        color={theme.colors.primary}
                        variant="small"
                      >
                        Specify the group id for the new feature flag. <br />
                        This allows targeted feature rollouts for specific
                        groups in a tenant.
                      </StandardText>
                    }
                  />
                )}

              <StandardButton
                text="Submit"
                onClick={() => this.addFeatureFlag()}
                disabled={
                  (newFeature && (!newFeatureName || !newDescription)) ||
                  (!newFeature && !existingFeatureToAddChosen) ||
                  (!newFeature &&
                    existingFeatureToAddChosen &&
                    !featureFlagLevelChosen) ||
                  (!newFeature &&
                    featureFlagLevelChosen === "tenant" &&
                    !tenantName) ||
                  (!newFeature &&
                    featureFlagLevelChosen === "site" &&
                    !spHostUrl)
                }
              ></StandardButton>

              <StatusMessage type="error">{addNewError}</StatusMessage>
              <StatusMessage type="success">{addNewMessage}</StatusMessage>
            </div>
          )}

          {productChosenNew === "cc" && (
            <div>
              <StandardDropdown
                label="Environment"
                placeholder="Select Environment"
                options={regionNames}
                selectedKey={regionNameChosenNewCC}
                onChange={this.onSelectRegionNameNewCC}
              ></StandardDropdown>

              {this.state.regionNameChosenNewCC != "" && (
                <StandardCheckbox
                  label="Add feature globally"
                  checked={newFeatureCC}
                  onChange={this.onCheckNewFeatureCC}
                ></StandardCheckbox>
              )}

              {newFeatureCC && this.state.regionNameChosenNewCC != "" && (
                <>
                  <StandardTextField
                    label="Feature Name"
                    placeholder="New Feature Name"
                    value={newFeatureNameCC}
                    onChange={(event, newValue) =>
                      this.setState({ newFeatureNameCC: newValue })
                    }
                  ></StandardTextField>

                  <StandardText
                    color={theme.colors.primary}
                    variant="small"
                    style={{ marginTop: "-16px", marginBottom: "15px" }}
                  >
                    The flag is created <b>disabled</b> for every tenant in this
                    environment. Enable it from Manage Existing Feature Flags
                    once you are ready to roll it out.
                  </StandardText>
                </>
              )}

              {!newFeatureCC && this.state.regionNameChosenNewCC != "" && (
                <StandardDropdown
                  label="Feature"
                  placeholder="Target Feature"
                  options={mainFeaturesCC}
                  selectedKey={existingFeatureToAddChosenCC}
                  onChange={this.onSelectFeatureToAddCC}
                  disabled={!regionNameChosenNewCC}
                ></StandardDropdown>
              )}

              {!newFeatureCC &&
                this.state.existingFeatureToAddChosenCC != "" && (
                  <StandardDropdown
                    label="Flag Level"
                    placeholder="Feature Flag Level"
                    options={[
                      { key: "tenant", text: "Tenant" },
                      { key: "sphost", text: "SPHost" },
                      { key: "team", text: "Team" },
                    ]}
                    selectedKey={featureFlagLevelChosenCC}
                    onChange={this.onSelectFeatureFlagLevelCC}
                    disabled={
                      !regionNameChosenNewCC || !existingFeatureToAddChosenCC
                    }
                  ></StandardDropdown>
                )}

              {!newFeatureCC && this.state.featureFlagLevelChosenCC != "" && (
                <div>
                  {this.state.featureFlagLevelChosenCC === "tenant" && (
                    <StandardTextField
                      label="Tenant ID"
                      placeholder="Tenant ID"
                      value={tenantIdCC}
                      onChange={(event, newValue) =>
                        this.setState({ tenantIdCC: newValue })
                      }
                      disabled={
                        !regionNameChosenNewCC ||
                        !existingFeatureToAddChosenCC ||
                        !featureFlagLevelChosenCC ||
                        featureFlagLevelChosenCC === "sphost" ||
                        featureFlagLevelChosenCC === "team"
                      }
                    ></StandardTextField>
                  )}

                  {this.state.featureFlagLevelChosenCC === "sphost" && (
                    <StandardTextField
                      label="SPHost"
                      placeholder="SPHost"
                      value={spHostUrlCC}
                      onChange={(event, newValue) =>
                        this.setState({ spHostUrlCC: newValue })
                      }
                      disabled={
                        !regionNameChosenNewCC ||
                        !existingFeatureToAddChosenCC ||
                        !featureFlagLevelChosenCC ||
                        featureFlagLevelChosenCC === "tenant" ||
                        featureFlagLevelChosenCC === "team"
                      }
                    ></StandardTextField>
                  )}

                  {this.state.featureFlagLevelChosenCC === "team" && (
                    <StandardTextField
                      label="Team ID"
                      placeholder="Team ID"
                      value={teamIdCC}
                      onChange={(event, newValue) =>
                        this.setState({ teamIdCC: newValue })
                      }
                      disabled={
                        !regionNameChosenNewCC ||
                        !existingFeatureToAddChosenCC ||
                        !featureFlagLevelChosenCC ||
                        featureFlagLevelChosenCC === "tenant" ||
                        featureFlagLevelChosenCC === "sphost"
                      }
                    ></StandardTextField>
                  )}
                </div>
              )}

              <StandardButton
                text="Submit"
                onClick={() =>
                  newFeatureCC
                    ? this.addGlobalFeatureFlagCC()
                    : this.addFeatureFlagCC()
                }
                disabled={
                  newFeatureCC
                    ? !regionNameChosenNewCC ||
                      !newFeatureNameCC ||
                      !newFeatureNameCC.trim()
                    : !existingFeatureToAddChosenCC ||
                      !featureFlagLevelChosenCC ||
                      (featureFlagLevelChosenCC === "tenant" && !tenantIdCC) ||
                      (featureFlagLevelChosenCC === "sphost" && !spHostUrlCC) ||
                      (featureFlagLevelChosenCC === "team" && !teamIdCC)
                }
              ></StandardButton>

              <StatusMessage type="error">{addNewErrorCC}</StatusMessage>
              <StatusMessage type="success">{addNewMessageCC}</StatusMessage>
              <StatusMessage type="warning">{addNewWarningCC}</StatusMessage>
            </div>
          )}
        </StandardScreen>
        <Dialog
          hidden={this.state.hideDeleteDialog}
          onDismiss={() =>
            this.setState({ hideDeleteDialog: true, flagToDelete: null })
          }
          dialogContentProps={{
            type: DialogType.normal,
            title: "Are you sure you want to delete this feature flag?",
            subText: "This action is irreversible, and cannot be un-done.",
          }}
          modalProps={{
            isBlocking: true,
            styles: { main: { maxWidth: 450 } },
          }}
        >
          <DialogFooter>
            <PrimaryButton
              onClick={() =>
                this.state.productChosen === "cc"
                  ? this.confirmDeleteFlagCC()
                  : this.confirmDeleteFlag()
              }
              text="Delete now"
            />
            <DefaultButton
              onClick={() =>
                this.setState({ hideDeleteDialog: true, flagToDelete: null })
              }
              text="Cancel"
            />
          </DialogFooter>
        </Dialog>
      </PageLayout>
    );
  }
}

export default FeatureFlags;
